import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { useTranslations } from '@unisporkal/localization';
import { useTheme } from '@unisporkal/themes';
import {
  Button,
  ButtonSizeEnum,
  ButtonVariantEnum,
} from '@unisporkal/alliance-ui';
import styles from './DropboxDownload.module.scss';

const DropboxDownload = ({ onDownloadLocallyClick, downloadMessage = '' }) => {
  const t = useTranslations();
  const theme = useTheme();
  const themeLink = theme.link || {};

  return (
    <span
      className={styles.dropboxDownload}
      data-testid="dropbox-download"
    >
      <div className={styles.item}>{downloadMessage}</div>
      <div className={styles.item}>
        <Button
          size={ButtonSizeEnum.LARGE}
          variant={ButtonVariantEnum.TEXT}
          data-testid="dropbox-download-button"
          className={cx(
            themeLink.buttonLink,
            themeLink.link,
            themeLink.confirmed,
            styles.dropboxButton
          )}
          onClick={onDownloadLocallyClick}
        >
          {t('dropbox_download_locally')}
        </Button>
      </div>
    </span>
  );
};

DropboxDownload.propTypes = {
  onDownloadLocallyClick: PropTypes.func.isRequired,
  downloadMessage: PropTypes.string,
};

export default DropboxDownload;
